import { render, staticRenderFns } from "./AgentChatSupportComponent.vue?vue&type=template&id=26fcfb42&scoped=true&"
import script from "./AgentChatSupportComponent.vue?vue&type=script&lang=js&"
export * from "./AgentChatSupportComponent.vue?vue&type=script&lang=js&"
import style0 from "./AgentChatSupportComponent.vue?vue&type=style&index=0&id=26fcfb42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fcfb42",
  null
  
)

export default component.exports